<div class="auth-wrapper">
  <div *ngIf="loader" id="loader"></div>

  <div class="hero card-glass mb-3">
    <p class="eyebrow">Spay · Sécurité</p>
    <h1>Réinitialiser votre mot de passe</h1>
    <p class="lead">Recevez un code par email ou SMS puis définissez un nouveau mot de passe.</p>
  </div>

  <div class="card card-glass p-3">
    <ul class="nav nav-pills glass-tabs mb-3" id="resetTabs" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link active" id="email-tab" data-bs-toggle="tab" data-bs-target="#email" type="button"
          role="tab" aria-controls="email" aria-selected="true">Email/SMS</button>
      </li>
    </ul>

    <div class="tab-content" id="resetTabsContent">
      <div class="tab-pane fade show active" id="email" role="tabpanel" aria-labelledby="email-tab">
        <div class="row g-3">
          <div class="col-lg-6" *ngIf="showTokenForm">
            <div class="card card-glass h-100">
              <div class="card-body">
                <p class="small ">Un code sera envoyé par e-mail ou SMS.</p>
                <form [formGroup]="resetTokenForm" #e="ngForm" (ngSubmit)="sendEmailToken(e.value)" class="row g-3">
                  <div class="col-12">
                    <label class="form-label">Email/Téléphone</label>
                    <input type="text" class="form-control" id="exampleInputEmail1" formControlName="identifier">
                    <p *ngIf="emailNotFound" class="text-danger mt-1">Cet e-mail est introuvable.</p>
                    <p *ngIf="phoneNotFound" class="text-danger mt-1">Ce numéro de téléphone est introuvable.</p>
                  </div>
                  <div class="col-12 d-grid">
                    <button type="submit" class="btn btn-primary btn-pill"
                      [disabled]="!resetTokenForm.valid">Envoyer</button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div class="col-lg-6" *ngIf="showPasswordForm">
            <div class="card card-glass h-100">
              <div class="card-body">
                <h5 class="mb-2">Nouveau mot de passe</h5>
                <p *ngIf="passwordChange" class="text-success">Votre mot de passe a été modifié avec succès.</p>
                <form [formGroup]="resetPasswordForm" #f="ngForm" (ngSubmit)="sendEmailTokenAndPassord(f.value)"
                  class="row g-3">
                  <div class="col-12">
                    <label class="form-label">Code</label>
                    <input formControlName="token" type="text" class="form-control" id="inputToken">
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Nouveau mot de passe</label>
                    <input formControlName="password" #pass (focus)="showvalidationpart()" (blur)="hidevalidationpart()"
                      (keyup)="validateValue(pass.value)" name="password" class="form-control" type="password" id="pass"
                      autocomplete="new-password" required>
                    <small *ngIf="password.invalid && (password.dirty || password.touched)" class="text-danger">Mot de
                      passe invalide</small>
                    <div *ngIf="validation" class="password-hints mt-1">
                      <p [ngStyle]="{'color':letterchange ? 'lightgreen' : '#ff9b9b' }">Minuscule</p>
                      <p [ngStyle]="{'color':capitalchange ? 'lightgreen' : '#ff9b9b' }">Majuscule</p>
                      <p [ngStyle]="{'color':numberchange ? 'lightgreen' : '#ff9b9b' }">Chiffre</p>
                      <p [ngStyle]="{'color':symbolechange ? 'lightgreen' : '#ff9b9b' }">Symbole</p>
                      <p [ngStyle]="{'color':lengthchange ? 'lightgreen' : '#ff9b9b' }">8-16 caractères</p>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Confirmer le mot de passe</label>
                    <input formControlName="confirmPassword" name="confirmPassword" class="form-control" type="password"
                      autocomplete="new-password" required>
                    <small *ngIf="resetPasswordForm.hasError('mismatch') && confirmPassword.touched"
                      class="text-danger">Les mots de passe sont différents.</small>
                  </div>
                  <div class="col-12 d-grid">
                    <button type="submit" class="btn btn-primary btn-pill"
                      [disabled]="!resetPasswordForm.valid">Envoyer</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>